import { Column } from "@tanstack/react-table";
import moment from "moment-timezone";
import React from "react";
import { RangeModifier } from "react-day-picker";
import { DebounceInput } from "react-debounce-input";

import { normalizeDateRangeForTimezone } from "src/library/utils/moment/normalizeDateRangeForTimezone";
import { DayRangePicker } from "src/library/components/DayRangePicker";
import { Select } from "src/library/components/Forms";
import { FilterType } from "src/types/table";

interface ColumnFilterProps<T = any> {
  column: Column<T, unknown>;
  filter: string;
  filterType: FilterType;
  options?: Array<{ text: string; value: string }>;
  minLength?: number;
}

export const ColumnFilter: React.FC<ColumnFilterProps> = ({
  column, filter, filterType, options, minLength
}) => {
  const handleDateChange = React.useCallback(({ from, to }: { from: Date; to: Date }) => {
    const utcDateRange = normalizeDateRangeForTimezone({
      from,
      to,
      snapToRangeBoundaries: true
    });

    column.setFilterValue(utcDateRange);
  }, [ column ]);

  switch (filterType) {
    case "dateRange":
      return (
        <DayRangePicker
          initialDateRange={column.getFilterValue() as RangeModifier}
          includeInput
          date={moment.utc().toDate()}
          minDate={moment.utc().subtract(10, "years").toDate()}
          maxDate={moment.utc().add(10, "years").toDate()}
          handleDateChange={handleDateChange}
        />
      );
    case "string":
      return (
        <DebounceInput
          debounceTimeout={1500}
          minLength={minLength || 2}
          value={(column.getFilterValue() as string | number) || ""}
          onChange={e => {
            column.setFilterValue(e.target.value);
          }}
          className="filter-input"
        />
      );
    case "select":
      if (options) {
        return (
          <Select
            value={filter ? filter : ""}
            label=""
            as="select"
            name="status"
            unselectedOption={{
              text: "Please Select",
              value: ""
            }}
            handleChange={e => column.setFilterValue(e.target.value)}
            options={options.map(option => ({
              text: option.text,
              value: option.value,
              checked: filter === option.value
            }))}
          />
        );
      }

      return null;
  }
};
